<main class="grid min-h-screen place-items-center bg-t-bg p-4">
  <div class="ic-surface w-full max-w-md p-8 text-center">
    <p class="m-0 text-[3rem] font-t-semibold leading-none text-t-accent-ink">404</p>
    <h1 class="ic-page-title mt-4">{{ _t("not_found_title") }}</h1>
    <p class="mt-2 text-t-base text-t-ink-2">{{ _t("not_found_message") }}</p>
    <div class="mt-6 flex justify-center">
      <a routerLink="/dashboard" class="ic-btn-primary">{{ _t("not_found_back_home") }}</a>
    </div>
  </div>
</main>
